import { render, staticRenderFns } from "./ContractSectionModal.vue?vue&type=template&id=012bdc20"
import script from "./ContractSectionModal.vue?vue&type=script&lang=js"
export * from "./ContractSectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports